import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import CondPag1 from '../imagens/CadCondPag/CondPag1.png';
import CondPag2 from '../imagens/CadCondPag/CondPag2.png';
import CondPag3 from '../imagens/CadCondPag/CondPag3.png';
import CondPag4 from '../imagens/CadCondPag/CondPag4.png';
import CondPag5 from '../imagens/CadCondPag/CondPag5.png';

export default class CadCondPag extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o Cadastro de Condição de Pagamento"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o Cadastro de Condição de Pagamento:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={CondPag1} alt="Condição 1"/>
                        </div>

                        <div className="gray_bar"></div>  

                        <div className="image-wrapper">
                            <img src={CondPag2} alt="Condição 2"/>
                        </div>                                            

                        <h3>No cadastro de Condição de Pagamentos nós temos:</h3>
                        <ol>
                            <li>Cadastrar uma nova Condição de Pagamento.</li>
                            <li>Filtro para busca de uma Condição de Pagamento usando a descrição.</li>
                            <li>Tabela exibindo as Condições de Pagamento que foram cadastradas até agora.</li>
                            <li>Botões auxiliares para trocar a situação.</li>
                            <li>Botões auxiliares para alterar/excluir a Condição de Pagamento.</li>
                            <li>Paginação da tabela de Condições de Pagamento.</li>
                        </ol>

                        <div className="gray_bar"></div>  

                        <h3>Como cadastrar uma nova Condição de Pagamento</h3>
                        <p>
                            Para cadastrar uma nova condição de pagamento basta clicar no botão "Adicionar".
                        </p>                       
                        <div className="image-wrapper">
                            <img src={CondPag3} alt="Condição 3"/>
                        </div>
                        <div className="image-wrapper">
                            <img src={CondPag4} alt="Condição 4"/>
                        </div>

                        <p>
                            Dentro da tela de cadastro você precisa preencher as informações corretamente depois clicar em "Salvar" para criar a nova condição de pagamento.
                        </p>
                        <p>
                            O campo Qtd. de Parcelas define quantas parcelas a condição de pagamento irá dividir o pagamento, sendo pagamentos parcelados sempre espaçados
                            de 30 em 30 dias. 
                        </p>
                        <p>
                            A opção "Contém Parcela à Vista" faz com que o pagamento da primeira parcela seja pagamento a vista. 
                        </p>

                        <p>
                            Lembresse que os campos com asterisco(*) são obrigatórios.
                        </p>
                        
                        <div className="gray_bar"></div>  

                        <h3>Como Alterar/Excluir uma Condição de Pagamento</h3>

                        <p>
                            Para alterar uma Condição de Pagamento você pode utilizar o coluna Situação da tabela para definir se a Condição de Pagamento está Ativa para uso ou 
                            não. E para alterar outras informações você pode utilizar o botão com o lápis na última coluna. 
                        </p>
                        <p>
                            Para excluir uma Condição de Pagamento basta utilizar o botão da lixeria na última coluna da tabela. Lembresse que não é possível excluir
                            uma Condição de Pagamento já utlizada em alguma venda.
                        </p>
                        <div className="image-wrapper">
                            <img src={CondPag5} alt="Condição 5"/>
                        </div>                        
                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/CadCondPag.js